import { put, take } from 'redux-saga/effects';
import { push } from 'react-router-redux';

import { popup_icon_type } from 'components/shared/popup/Popup';
import { getText } from 'misc/helpers';
import * as endpoint from 'misc/endpoint';
import * as types from 'misc/types';

export function* getVerifications(action) {
    try {
        const response = yield endpoint.get(`verifications/${action.token}`);
        yield put({ type: types.SAGA_VERIFICATIONS.SUCCESS, payload: response.data.data });
    } catch (error) {
        yield put({ type: types.SAGA_VERIFICATIONS.FAILURE, error: error.message });

        yield put({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.error,
                header: '',
                text: error.message
            }
        });

        yield take(types.POPUP_HIDE);
        yield put(push('/'));
    }
}



// WEBPACK FOOTER //
// ./src/sagas/verifications.js